import { tokenStorage } from './apiClient';
import { getDeviceId } from './deviceId';

/**
 * Headers for a raw playback-START fetch (the `.m3u8` probe + sports-vod
 * preflight bypass `api()`). Sends the device header (for the screen gate) and,
 * when `auth`, the Bearer token. NOT used for segment fetches — those stay
 * "simple" cross-origin GETs (see useHlsPlayer xhrSetup / isSignedProxyUrl).
 */
export function playbackHeaders(auth = true): Record<string, string> {
  const headers: Record<string, string> = { 'x-cobstream-device': getDeviceId() };
  if (auth) {
    const token = tokenStorage.get();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}
